<template>
  <v-card class="pa-4">
    <div class="text-center">
      <h2>Adicionar Template</h2>
    </div>

    <v-form ref="form" class="my-4">
      <v-row class="ma-0">
        <v-col cols="12" sm="5">
          <label class="ml-1">Nome:</label>
          <v-text-field
            v-model="template.name"
            class="primary-input"
            outlined
            dense
            placeholder="Insira um nome para o template"
            hide-details="auto"
            :rules="[(v) => !!v || 'Nome obrigatório']"
          ></v-text-field>
        </v-col>
        <v-col>
          <label class="ml-1">Analisador:</label>
          <v-autocomplete
            v-model="template.analyzerId"
            :items="analysers"
            item-text="name"
            item-value="id"
            class="primary-input"
            outlined
            dense
            placeholder="Insira um nome para o template"
            hide-details="auto"
            :rules="[(v) => !!v || 'Nome obrigatório']"
          ></v-autocomplete>
        </v-col>
      </v-row>

      <strong class="my-2">Testes:</strong>

      <v-card class="pa-2 tests" outlined>
        <div v-for="test in template.tests" :key="test.id">
          <v-card class="pa-2 ma-1" flat color="#e9e9e9">
            <v-row class="ma-0" dense>
              <v-col cols="12" sm="4">
                <label class="text-caption">Nome:</label>
                <v-text-field
                  v-model="test.name"
                  class="primary-input"
                  outlined
                  dense
                  placeholder="Dê um nome ao teste"
                  hide-details="auto"
                  :rules="[(v) => !!v || 'Nome obrigatório']"
                ></v-text-field>
              </v-col>
              <v-col cols="12" sm="7">
                <label class="text-caption">Comando:</label>
                <v-text-field
                  v-model="test.command"
                  class="primary-input"
                  outlined
                  dense
                  placeholder="Insira o comando"
                  hide-details="auto"
                  :rules="[(v) => !!v || 'Comando obrigatório']"
                ></v-text-field>
              </v-col>
              <v-col cols="12" sm="1">
                <v-btn
                  color="error"
                  depressed
                  icon
                  text
                  @click="
                    template.tests = template.tests.filter((x) => x != test)
                  "
                >
                  <v-icon>mdi-trash-can-outline</v-icon>
                </v-btn>
              </v-col>

              <v-col cols="12" sm="4">
                <label class="text-caption">Tolerância mínima:</label>
                <v-text-field
                  v-model="test.toleranceMin"
                  class="primary-input"
                  type="number"
                  outlined
                  dense
                  placeholder="Insira o tolerância mínima"
                  hide-details="auto"
                  :rules="[(v) => !!v || 'Tolerância mínima obrigatório']"
                ></v-text-field>
              </v-col>

              <v-col cols="12" sm="4">
                <label class="text-caption">Tolerância máxima:</label>
                <v-text-field
                  v-model="test.toleranceMax"
                  class="primary-input"
                  type="number"
                  outlined
                  dense
                  placeholder="Insira o tolerância máxima"
                  hide-details="auto"
                  :rules="[(v) => !!v || 'Tolerância máxima obrigatório']"
                ></v-text-field>
              </v-col>

              <v-col cols="12" sm="4">
                <label class="text-caption">Tolerância:</label>
                <v-text-field
                  v-model="test.tolerance"
                  class="primary-input"
                  type="number"
                  outlined
                  dense
                  placeholder="Insira a tolerância"
                  hide-details="auto"
                  :rules="[(v) => !!v || 'Tolerância obrigatório']"
                ></v-text-field>
              </v-col>
            </v-row>
          </v-card>
        </div>
        <v-btn
          @click="template.tests.push({})"
          class="ma-1 secondary"
          style="border-radius: 6px"
          depressed
        >
          Adicionar teste
        </v-btn>
      </v-card>
    </v-form>

    <div class="d-flex justify-end">
      <v-btn
        @click="save"
        :loading="loading"
        color="secondary"
        depressed
        class="ma-0"
      >
        Salvar
      </v-btn>
    </div>
  </v-card>
</template>

<script>
import ApiService from '../../../../../services/ApiService'
export default {
  name: 'ManageAnalyser',

  props: {
    templateProp: Object,
  },

  created() {
    if (this.templateProp.id) {
      this.template = { ...this.templateProp }
      this.isEditing = true
    }

    const institution = JSON.parse(localStorage.getItem('institution'))
    this.template.institutionId = institution.id

    this.getAnalysers()
  },

  data() {
    return {
      analysers: [],
      isEditing: false,
      apiService: new ApiService(),
      template: { name: '', tests: [] },
      loading: false,
    }
  },

  methods: {
    getAnalysers() {
      this.apiService
        .get(`electricalSafetyAnalyser/${this.template.institutionId}`)
        .then((response) => {
          this.analysers = response.content
        })
    },

    removeTest(test) {
      const index = this.template.tests.indexOf(test)
      if (index > -1) array.splice(index, 1)
    },

    save() {
      if (this.$refs.form.validate()) {
        this.loading = true

        this.template.tests = this.template.tests.map((x) => {
          x.institutionId = this.template.institutionId
          return x
        })

        if (this.isEditing) {
          this.apiService
            .put('electricalSafetyAnalyserTemplate', this.template)
            .then(() => {
              this.$toast.success('Checklist cadastrado com sucesso!')
              this.$emit('close')
              this.loading = false
            })
            .catch(() => {
              this.loading = false
            })
        } else {
          this.apiService
            .post('electricalSafetyAnalyserTemplate', this.template)
            .then(() => {
              this.$toast.success('Checklist atualizado com sucesso!')
              this.$emit('close')
              this.loading = false
            })
            .catch(() => {
              this.loading = false
            })
        }
      }
    },
  },
}
</script>

<style scoped>
.tests {
  max-height: 300px;
  overflow-y: auto;
}

.tests::-webkit-scrollbar {
  width: 8px;
  background: #e9e9e9;
}

.tests::-webkit-scrollbar-thumb {
  width: 8px;
  border-radius: 6px;
  background: #d9d9d9;
}
</style>
